(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyBookingDeleteController',DinghyBookingDeleteController);

    DinghyBookingDeleteController.$inject = ['$uibModalInstance', 'entity', 'DinghyBooking'];

    function DinghyBookingDeleteController($uibModalInstance, entity, DinghyBooking) {
        var vm = this;

        vm.dinghyBooking = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DinghyBooking.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
